import { Field, ErrorMessage } from "formik"
import { useState, useEffect } from "react";
import CreditCardInputs from "./CreditCardInputs"
import VoucherInputs from "./VoucherInputs";

export default function Pago({ col = false, setContado, contado=false, productos, setMensaje, botonesDescripcion, centro, setModal, setFieldValue, values, errors, touched, enableVoucher, formaPago, facturaSeleccionada=undefined, mensaje }) {
    
   const [total, setTotal] = useState(()=>
       productos.reduce((acc, producto) => {
           let { Unidad, Precio, qty } = producto;
           if (Number.isNaN(Precio)) Precio = Number(Precio.replace(/Q/g, '').trim())
           return acc + (Unidad * Precio * qty);
        }, 0)    
    )
    const [subtotal, setSubtotal] = useState(0)
    const handleBlur = (e, setFieldValue, flag) => {

        const { efectivo, tarjeta, /*voucher*/ } = values;
        const voucher = enableVoucher ? values.voucher : null

        const subtotal = enableVoucher 
            ? Number(efectivo) + Number(tarjeta) + Number(voucher)
            : Number(efectivo) + Number(tarjeta)

        setSubtotal(()=>String(subtotal))

        setFieldValue('monto', total);
    }

    const handleChange = (e, setFieldValue, flag) => {
  
        const isEmpty = productos.some(item => item.qty === 0)


         // condicionar pára que funcione aquí
         if(!facturaSeleccionada){
             if(productos.length === 0){
                 setMensaje(true) // setearlo a false
                 setFieldValue('tarjeta', 0)
                 setFieldValue('efectivo', 0)
                 return setModal({
                msg: 'Seleccione un producto para ingresar formas de pago.',
                ok: false,
                show: true
                })
            }
         }else{
            setFieldValue('tarjeta', `${facturaSeleccionada.TotalFactura}.00`)
            setFieldValue('efectivo', `${facturaSeleccionada.TotalFactura}.00`)
         }

        if(isEmpty){
            setMensaje(() => {return true})
            setFieldValue('tarjeta', '')
            setFieldValue('efectivo', '')
            return setModal({
                msg: 'Ingrese la cantidad en todos los productos.',
                ok: false,
                show: true
            })
        }
        setFieldValue(flag, e.target.value)
    }

    useEffect(() => {
        if(productos.length === 0){
            setFieldValue('efectivo', 0)
            setFieldValue('tarjeta', 0)
            setSubtotal(() => {return values.efectivo + values.tarjeta})
        }else{

        }
        setTotal(()=> productos.reduce((acc, producto) => {
            let { Unidad, Precio, qty } = producto;
            if (Number.isNaN(Precio)) Precio = Number(Precio.replace(/Q/g, '').trim())
            return acc + (Unidad * Precio * qty);
         }, 0))
    }, [productos])

    useEffect(() => { 
      if(contado === 0){
        setFieldValue('tarjeta', 0)
      }
    }, [contado])
    

    const getFormaPago = (formaParam) => {
        const opciones = {
            0 : "al crédito",
            1: "transferencia",
            2: "tarjeta",
            3: "boleta",
            9: "extensión de IVA"
        }
      return opciones[formaParam] || "efectivo"
    }
    
    useEffect(() => {
        let sumatoria;
        let cantidad = `${Number.parseFloat(sumatoria).toFixed(2)}`
        if (contado === 0){
            if(productos.length>0) {
              sumatoria = productos.reduce( (prev, next) => prev + (next?.Precio * next?.qty)  , 0)
            }else{
                // cuando están en facturas, probablemente no se va a ejecutar
              sumatoria = facturaSeleccionada?.TotalFactura || 0
            }
            setFieldValue('efectivo', !sumatoria.toString().includes('.')? cantidad : sumatoria)
            setSubtotal(sumatoria)
            setTotal(sumatoria)
        }
        if(contado === 1){
            sumatoria = productos.reduce( (prev, next) => prev + (next?.Precio * next?.qty)  , 0)
            if(formaPago === 1){
                setFieldValue('efectivo', cantidad)
                setFieldValue('monto', sumatoria)
                setSubtotal(sumatoria)
                setTotal(sumatoria)
            }
            if(formaPago === 2){
                setFieldValue('tarjeta', cantidad)
                setFieldValue('monto', sumatoria)
                setSubtotal(sumatoria)
                setTotal(sumatoria)
            }
            if(formaPago === 3){
                setFieldValue('efectivo', cantidad)
                setFieldValue('monto', sumatoria)
                setSubtotal(sumatoria)
                setTotal(sumatoria)
            }
        }
      }, [productos])
    
      useEffect(() => {
          let reducidor = productos.reduce((prev, next) => prev + (next.Precio * next.qty)  , 0)
        let numero = `${Number.parseFloat(productos.reduce( (prev, next) => prev + (next.Precio * next.qty)  , 0)).toFixed(2)}`
        if(formaPago === 1 ){
            setFieldValue('efectivo', numero)
            setSubtotal(reducidor)
            setFieldValue('tarjeta',  0)
        }
        if(formaPago === 2 ){
            setFieldValue('tarjeta', numero)
            setSubtotal(reducidor)
            setFieldValue('efectivo',  0)
        }
        if(formaPago === 3 ){
            setFieldValue('efectivo', numero)
            setSubtotal(reducidor)
            setFieldValue('tarjeta',  0)
        }
      }, [formaPago])
      
      useEffect(() => {
      if(facturaSeleccionada){
        setFieldValue('tarjeta', `${facturaSeleccionada.TotalFactura}.00`)
        setSubtotal(facturaSeleccionada.TotalFactura)
        setTotal(facturaSeleccionada.TotalFactura)
      }
      }, [])
    
    return (
            <div className="px-4 py-5 sm:p-6">
                <div className={col?"lg:grid lg:grid-cols-2 lg:gap-5" : "lg:grid lg:grid-cols-3 lg:gap-5 ml-3"}>
                    <div className={col?"lg:col-span-2":"lg:col-span-1"}>
                        <h3 className="text-lg font-medium leading-6 text-white">4. Forma de pago</h3>
                        <p className="py-2 text-sm text-grisMira">Rellene la información respectiva a las formas de pago.</p>
                        
                    </div>
                    <div className="mt-5 lg:col-span-2 lg:mt-0">

                        <div className="grid grid-cols-6 gap-3">
                            <div className="order-last col-span-full bg-primarioMira px-5 flex items-center justify-between border-t border-gray-200 mt-5 pt-5 text-gray-900">
                                <p className="text-base font-semibold text-grisMira">Subtotal</p>
                                <p className="text-base font-semibold /text-white">
                                    <span className={`${Number(total) === Number(subtotal) ? 'bg-green-300 text-green-800' : 'bg-red-300 text-red-800'} px-2 py-1 rounded-full`}>
                                        {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(subtotal)}
                                    </span>
                                </p>
                            </div>
                            <div className="order-last col-span-full bg-secundarioMira p-5 flex items-center justify-between border-t border-gray-200 mt-5 pt-5 text-gray-900">
                                <p className="text-base font-semibold text-grisMira">Total</p>
                                <p className="text-base font-semibold text-white">{Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(total)}</p>
                            </div>

                            {[2].includes(formaPago)? <div className="col-span-6 sm:col-span-6 lg:col-span-3 w-1/2"></div>:
                            <div className="col-span-6 sm:col-span-6 lg:col-span-3 ">
                                <div className="flex flex-col ">
                                    <label className="block text-sm font-medium text-grisMira">
                                        {`Monto pago ${formaPago ? getFormaPago(formaPago): getFormaPago(contado)}`}
                                    </label>
                                    <ErrorMessage component="p" name="efectivo" className="w-full text-left block text-sm font-semibold text-red-500 mt-2"/>
                                </div>
                                <Field
                                    onKeyUp={(e) => handleBlur(e, setFieldValue, 'efectivo')}
                                    onChange={(e) => handleChange(e, setFieldValue, 'efectivo')}
                                    name='efectivo'
                                    type='number'
                                    min={0}
                                    disabled={facturaSeleccionada?.CondicionPago === "Credito" ? true : false}
                                    step={0.01}
                                    onFocus={() => !values.efectivo && setFieldValue('efectivo', '')}
                                    onBlur={() => !values.efectivo && setFieldValue('efectivo', 0)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                    />
                            </div>
                            }

                            {[1,3].includes(formaPago) || contado===0? <div></div>:
                            <div className="col-span-6 sm:col-span-6 lg:col-span-3 ">
                                
                                <div className="flex /justify-between flex-col">
                                    <label className="block text-sm font-medium text-grisMira">
                                        Monto pago tarjeta
                                    </label>
                                    <ErrorMessage component="p" name="tarjeta" className="w-full text-left block text-sm font-semibold text-red-500 mt-2"/>
                                </div>
                                <Field
                                    onKeyUp={(e) => handleBlur(e, setFieldValue, 'tarjeta')}
                                    onChange={(e) => handleChange(e, setFieldValue, 'tarjeta')}
                                    name='tarjeta'
                                    type='number'
                                    disabled={facturaSeleccionada?.CondicionPago === "Credito" ? true : false}
                                    onFocus={()=> !values.tarjeta && setFieldValue('tarjeta', '')}
                                    onBlur={()=> !values.tarjeta && setFieldValue('tarjeta', 0)}
                                    min={0}
                                    step={0.01}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                />
                            </div>}

                            {enableVoucher ?
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                <div className="flex justify-between">    
                                    <label className="block text-sm font-medium text-grisMira">
                                        Monto Pago Voucher
                                    </label>
                                    <ErrorMessage component="p" name="voucher" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                </div>
                                <Field
                                    onKeyUp={(e) => handleBlur(e, setFieldValue, 'voucher')}
                                    onChange={(e) => handleChange(e, setFieldValue, 'voucher')}
                                    name='voucher'
                                    type='number'
                                    min={0}
                                    step={0.01}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                />
                            </div>: null}

                            {(centro && formaPago === null) ? null :

                                (values.tarjeta > 0 || facturaSeleccionada)?
                                  //[1].includes(contado)?
                                    <CreditCardInputs
                                        setModal={setModal}
                                        setFieldValue={setFieldValue}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                    />
                                : null
                            }

                            {enableVoucher &&
                                values.voucher > 0 ?
                                    <VoucherInputs
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        errors={errors}
                                    />
                                : null
                            }

                        </div>
                    </div>
                </div>
            </div>
    )
}